// extracted by css-extract-rspack-plugin
export default {"wrapper":"_bb2a5301"};